// helper for yup transform function
export function emptyStringToUndefined(value, originalValue) {
   if (typeof originalValue === "string" && originalValue === "") {
      return undefined;
   }
   return value;
}
export function emptyStringToNull(value, originalValue) {
   if (typeof originalValue === "string" && originalValue === "") {
      return null;
   }
   return value;
}
export function emptyValuesToUndefined(value, originalValue) {
   if (typeof originalValue === "string" && originalValue === "") {
      return undefined;
   }
   if (originalValue === null)
      return undefined;

   if (typeof value === "string" && value === "") {
      return undefined;
   }

   if (value === null)
      return undefined;

   return value;
}